import type { CSSProperties } from 'react';
import type { PhotoPosition } from '../../types/photo';

export interface PhotoGuidelineImageData {
  previewUrl: string;
  fileName: string;
  fileSize: number;
  fileType: string;
  file?: File;
}

export type PhotoGuidelineSlot = 'front' | 'back' | 'rightSide' | 'leftSide';

export const PHOTO_GUIDELINE_SLOTS: PhotoGuidelineSlot[] = [
  'front',
  'back',
  'rightSide',
  'leftSide',
];

export const hasAllGuidelinePhotos = (
  photos: Record<PhotoGuidelineSlot, PhotoGuidelineImageData | null>,
): boolean => PHOTO_GUIDELINE_SLOTS.every((slot) => photos[slot] !== null);

export const getMissingGuidelinePhotoSlots = (
  photos: Record<PhotoGuidelineSlot, PhotoGuidelineImageData | null>,
): PhotoGuidelineSlot[] => PHOTO_GUIDELINE_SLOTS.filter((slot) => !photos[slot]);

export const getPhotoGuidelineSectionId = (slot: PhotoGuidelineSlot): string =>
  `photo-guideline-${slot}`;

export const PHOTO_SLOT_TO_POSITION: Record<PhotoGuidelineSlot, PhotoPosition> = {
  front: 'front',
  back: 'back',
  rightSide: 'right',
  leftSide: 'left',
};

export interface PhotoGuidelinesProps {
  photos: Record<PhotoGuidelineSlot, PhotoGuidelineImageData | null>;
  missingSlots?: PhotoGuidelineSlot[];
  onSelectPhoto: (slot: PhotoGuidelineSlot) => void;
  onRemovePhoto: (slot: PhotoGuidelineSlot) => void;
}

export type PositionGuideKey = 'front' | 'back' | 'right_side' | 'left_side';

export interface InstructionPointStyle {
  connectorLine: CSSProperties;
  lineDot: CSSProperties;
  text: CSSProperties;
}

export interface PositionGuideConfig {
  head: InstructionPointStyle;
  torso: InstructionPointStyle;
  arms: InstructionPointStyle;
  feet: InstructionPointStyle;
}
